<template>
  <div>
    <el-dialog :title="$t('text.reverse')"
               :visible="isShowReverseDialog"
               width="600px"
               @close="handleDialog"
               :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item :label="$t('text.orderAmount')" v-if="this.orderAmount != null">
          <el-input size="small"
                    type="text"
                    v-model="orderAmount"
                    disabled/>
        </el-form-item>
        <el-form-item prop="refId" :label="$t('text.refId')" v-if="this.$store.state.isBD && isPayin">
          <el-input size="small"
                    type="text"
                    v-model="form.refId"
                    :placeholder="$t('message.inputRefId')"/>
        </el-form-item>

        <el-form-item :label="$t('text.realPay')" prop="actualAmount" v-if="this.orderAmount != null || (this.$store.state.isBD && isPayin)">
          <el-input size="small"
                    type="text"
                    v-model="form.actualAmount"
                    :placeholder="$t('message.inputRealPay')"/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialog">{{ $t('text.cancel') }}</el-button>
        <el-button type="primary" @click="submit">{{ $t('text.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    isShowReverseDialog: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ""
    },
    orderAmount: {
      type: String,
      default: null
    },
    refId: {
      type: String,
      default: ""
    },
    isPayin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const generateRules = () => {
      const rules = {
        toStatus: [{required: true, message: this.$t('message.orderStatusRequiredError'), trigger: "change"}],
        actualAmount: [{validator: this.validateAmount, trigger: "change"}],
      };
      if (this.$store.state.isBD) {
        rules.refId = [{validator: validateRefId, trigger: "change"}];
      }

      return rules;
    };

    let validateRefId = (rule, value, callback) => {
      if (this.form.toStatus === '01') {
        if (!value) {
          callback(new Error(this.$t('message.inputRefId')));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };

    return {
      form: {
        actualAmount: null,
        refId: this.refId,
      },
      rules: generateRules()
    };
  },
  watch: {
    isShowReverseDialog(val) {
      if (val) {
        this.form.refId = this.refId;
      }
    }
  },
  methods: {
    handleDialog() {
      this.$refs["form"].resetFields();
      this.form = {
        actualAmount: null,
        refId: "",
      };
      this.$emit("update:isShowReverseDialog", false);
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.refId && this.form.toStatus) {
            if (this.refId !== this.form.refId) {
              this.$confirm(this.$t('message.confirmModifyRefId'), this.$t('text.prompt'), {
                confirmButtonText: this.$t('text.confirm'),
                cancelButtonText: this.$t('text.cancel'),
                type: 'warning'
              }).then(() => {
                this.submitForm();
              }).catch(() => {
              })
            } else {
              this.submitForm();
            }
          } else {
            this.submitForm();
          }
        }
      });
    },
    submitForm() {
      const params = {
        ...this.form,
        orderId: this.id
      };
      this.$axios.post("/order/reverseOrderStatus", params).then((res) => {
        if (res.code === 200) {
          this.$notify({
            title: this.$t('text.prompt'),
            message: res.msg,
            type: "success"
          });
          this.$emit("update:isShowReverseDialog", false);
          this.$bus.$emit("refresh"); //通知刷新
        } else {
          this.$notify.error({
            title: this.$t('text.prompt'),
            message: res.msg
          });
        }
      });
    },
    validateAmount(rule, value, callback) {
      if (value == null){
        callback();
      }
      const submitAmount = parseFloat(value);
      if (isNaN(submitAmount) || submitAmount <= 0) {
        callback(new Error(this.$t('message.numericError')));
      } else {
        callback();
      }
    }
  }
};
</script>
